import React from 'react';
import { MdOutlineMoreHoriz } from "react-icons/md";
import { FaPencilAlt } from 'react-icons/fa';
import { FaUsers, FaShoppingCart, FaCartPlus } from "react-icons/fa";
import ButtonTooltip from '../../components/Inputs/ButtonTooltip';
import { AiFillDislike, AiFillLike } from "react-icons/ai";
import { ImUnlocked } from 'react-icons/im';
import { Pergunta } from '../../util/Alertas';

function BloquearClientesTable({ clientes, Desbloquear, filtroNome }) {

    const FormataData = (data) => data ? new Date(data).toLocaleDateString() : '-';

    return (
        <div className='row'>
            <div className="col-md-12">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Telefone</th>
                            <th>Data Bloqueio</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientes.filter(x => x.nome.toLocaleLowerCase().includes(filtroNome.toLocaleLowerCase())).map((cliente) => (
                            <tr key={cliente.id}>
                                <td data-label="Nome" >{cliente.nome}</td>
                                <td data-label="Email" >{cliente.email}</td>
                                <td data-label="Telefone" >{cliente.telefone}</td>
                                <td data-label="Data Bloqueio" >{FormataData(cliente.dataBloqueadoAtraso)}</td>
                                <td>
                                    <ButtonTooltip
                                        text={"Desbloquear Cliente"}
                                        textButton={<ImUnlocked />}
                                        className={`btn btn-success`}
                                        top={true}
                                        onClick={() => Desbloquear(cliente.id, cliente.nome)}
                                    />
                                </td>
                            </tr>
                        ))}
                        {clientes.length == 0 && <tr>
                            <td><span>Não foi encontrado nenhum cliente...</span></td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                        </tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default BloquearClientesTable;


